import { setReportTcss } from '@utils/report.js';
import Vue from 'vue';

export default (router) => {
  // 路由切换前未激活阶段时被调用
  // router.beforeEach((to, _, next) => {
  //   next();
  // });

  // 路由切换成功进入激活阶段时被调用
  router.afterEach((to) => {
    Vue.prototype.$routeList.push(to);
    // route_end = new Date();
    // tcss点击流
    const { meta, name, path } = to;
    const prePath = '/ingame/all';
    setTimeout(() => {
      setReportTcss({
        name: meta.pageName || name,
        type: meta.pageType || name,
        path: prePath + path,
      });
    }, 0);
  });
};
